"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = flexRight;
function flexRight() {
  return /*css*/"\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  ";
}